module.exports = __webpack_public_path__ + "img/mm-white-logo-en.a76bc005.png";